import { prepareInvitedMember } from '../member';
import { prepareInvitationCommon } from './prepare-invitation-common';
export const prepareIndividualInvitation = async ({ adminCrypto, emails, groupIds, principalsCrypto, workspaceId, }) => {
    const adminKeys = await adminCrypto.verifyAndGetAdminKeys();
    const [workspaceCommonKey, everyoneKeys, ssoSecretKey] = await Promise.all([
        adminCrypto.getWorkspaceCommonKey(),
        adminCrypto.verifyAndGetEveryoneKeys(),
        adminCrypto
            .getSsoCrypto()
            .then((ssoCrypto) => ssoCrypto.verifyAndGetSsoSecretKey()),
    ]);
    const invitationCommon = await prepareInvitationCommon({
        workspaceId: workspaceId,
        adminKeys,
        workspaceCommonKey,
        everyonePrivateKey: everyoneKeys.privateKey,
        workspaceSecretKey: ssoSecretKey,
    });
    const members = await Promise.all(emails.map(async (email) => {
        return prepareInvitedMember({
            workspaceId,
            invitationKeys: invitationCommon.invitationKeys,
            email,
            principalsCrypto,
            groupIds: groupIds ?? [],
        });
    }));
    return {
        ...invitationCommon,
        invitation: {
            ...invitationCommon.invitation,
            members,
        },
    };
};
